import { render, staticRenderFns } from "./CarSignage.vue?vue&type=template&id=bddb322e&scoped=true&"
import script from "./CarSignage.vue?vue&type=script&lang=ts&"
export * from "./CarSignage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddb322e",
  null
  
)

export default component.exports